import { Form, TableProps } from 'antd';
import TcForm from 'components/UI/form/TcForm';
import TcFormButtons from 'components/UI/FormButtons/TcFormButtons';
import TcPagination from 'components/UI/Pagination/TcPagination';
import TcTable from 'components/UI/Table/TcTable';
import { IBackendSearchGeneric, ITableColumn } from 'global/Models/globalModels';
import { FC, ReactNode, useEffect, useState } from 'react';
import CollapseWrapper from '../CollapseWrapper/CollapseWrapper';
import TcFormWrapper from '../FormWrapper/TcFormWrapper';

interface ITcListPageNoQuery {
  columns: ITableColumn[];
  getList: (_a: object) => void;
  loading: boolean;
  list: IBackendSearchGeneric<any> | undefined;
  filterItems?: ReactNode;
  tableProps?: TableProps<any>;
  moreContent?: ReactNode;
}

const TcListPageNoQuery: FC<ITcListPageNoQuery> = ({ columns, getList, loading, list, filterItems, tableProps, moreContent }) => {
  //states
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);

  //hooks
  const [form] = Form.useForm();

  //effect
  useEffect(() => {
    getList({ pageNumber, recordsPerPage });
  }, []);

  //functions
  const handleSubmit = (values: object): void => {
    getList({ ...values, pageNumber, recordsPerPage });
  };
  const handleReset = () => {
    form.resetFields();
    setPageNumber(1);
    getList({ pageNumber: 1, recordsPerPage });
  };
  const handlePagination = (pageNumber = 1, recordsPerPage = 10) => {
    setPageNumber(pageNumber);
    setRecordsPerPage(recordsPerPage);
    getList({ ...form.getFieldsValue(), pageNumber, recordsPerPage });
  };

  return (
    <>
      {filterItems && (
        <TcForm form={form} onFinish={handleSubmit} className='mb-6'>
          <CollapseWrapper>
            <TcFormWrapper className='py-4 px-2 gap-3'>{filterItems}</TcFormWrapper>
            <TcFormButtons onCancel={handleReset} />
          </CollapseWrapper>
        </TcForm>
      )}

      {moreContent && moreContent}

      <TcTable
        count={list?.totalItemCount}
        refetch={() => getList({ ...form.getFieldsValue, pageNumber, recordsPerPage })}
        dataSource={list?.data || []}
        columns={columns}
        loading={loading}
        current={pageNumber}
        pageSize={recordsPerPage}
        tableProps={tableProps}
      />
      <TcPagination current={pageNumber} pageSize={recordsPerPage} total={list?.totalItemCount} onPaginationHandler={handlePagination} />
    </>
  );
};

export default TcListPageNoQuery;
